<template>
  <div class="sidebar-container">
    <logo :collapse="isCollapse" />
    <el-scrollbar>
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :active="isActive(route)"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
    <div class="qrcode" v-if="sidebar.opened">
      <img
        class="qrcode-img"
        src="https://upload.goldentec.com/frontend/invoice-yunnan-block/yunnan-qr-customer-service.jpg"
        alt="侧边栏扫码获取技术支持"
        srcset=""
      />
      <p class="qrcode-text">扫码关注获取技术支持</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Scrollbar, Menu } from "element-ui";
import Logo from "./logo";
import SidebarItem from "./sidebar-item";
import { urlToList } from "@/utils";

export default {
  components: { ElScrollbar: Scrollbar, ElMenu: Menu, SidebarItem, Logo },
  computed: {
    ...mapGetters(["sidebar"]),
    routes() {
      // route.hidden if set true, item will not show in the sidebar
      return (this.$store.getters.routes || []).filter(
        (route) => !route.hidden && route.meta && route.meta.title
      );
    },
    activeMenu() {
      const { meta, path } = this.$route;

      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }

      return path;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  methods: {
    isActive(route) {
      const urlList = urlToList(this.activeMenu);
      return route.path === urlList[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-container {
  position: relative;
  transition: width 0.28s;
  width: $sideBarWidth;
  background-color: $menuBg;
  position: fixed;
  font-size: 0px;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow: hidden;
  box-shadow: -5px 0 7px 0px rgba(0, 0, 0, 0.5);
  padding-bottom: 150px;

  // reset element-ui css
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }

  ::v-deep .el-scrollbar__bar.is-vertical {
    right: 0px;
  }

  ::v-deep .el-scrollbar {
    height: calc(100% - 50px);
  }

  ::v-deep .el-scrollbar__bar.is-horizontal {
    display: none;
  }

  .qrcode {
    position: absolute;
    bottom: 10px;
    width: 100%;
    height: 132px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;

    .qrcode-img {
      width: 108px;
      height: 108px;
    }

    .qrcode-text {
      width: 100%;
      margin-top: 8px;
      height: 16px;
      line-height: 16px;
      color: #666666;
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>

<style lang="scss">
// el-menu
.sidebar-container .el-menu {
  width: 100%;
  height: 100%;
  border: 0;

  a {
    display: inline-block;
    width: 100%;
    text-decoration: none;
  }

  .svg-icon {
    width: 16px;
    height: 16px;
    color: #909399;
    margin-right: 6px;
    vertical-align: middle;
  }

  .el-menu-item {
    position: relative;
    min-width: $sideBarWidth;
    color: $menuText;

    .el-menu-item--hover {
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      height: 50px;
      background-color: $color-primary;
    }

    &:hover,
    &:focus {
      background-color: #e8f3ff;
      .el-menu-item--hover {
        width: 4px;
      }
    }
    &.is-active {
      background-color: #e8f3ff;
    }
  }

  // menu-title
  .el-submenu__title,
  .el-menu-item.submenu-title-noDropdown {
    font-size: 14px;
    font-weight: 600;
    color: $menuText;
  }

  .nest-menu .el-menu-item {
    font-size: 14px;
    padding-left: 42px !important;
  }

  .el-menu-item.submenu-title-noDropdown .el-menu-item--hover {
    height: 56px;
  }

  .el-menu-item.is-active,
  .el-menu-item.is-active .svg-icon,
  .el-submenu.is-active .el-submenu__title,
  .el-submenu.is-active .el-submenu__title .svg-icon {
    color: $menuActiveText;
  }

  // when menu collapsed
  &.el-menu--collapse {
    // menu-item
    .el-menu-item.submenu-title-noDropdown {
      min-width: 50px;
      padding: 0 !important;
      position: relative;

      .el-tooltip {
        padding: 0 !important;

        .svg-icon {
          margin-left: 20px;
        }
      }
    }

    // submenu
    .el-submenu {
      overflow: hidden;

      & > .el-submenu__title {
        padding: 0 !important;

        .svg-icon {
          margin-left: 20px;
        }

        .el-submenu__icon-arrow {
          display: none;
        }

        & > span {
          height: 0;
          width: 0;
          overflow: hidden;
          visibility: hidden;
          display: inline-block;
        }
      }
    }
  }
}

// when menu collapsed
.el-menu--vertical {
  // menu link
  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-decoration: none;
  }

  // menu icon
  .svg-icon {
    color: #909399;
    margin-right: 16px;
  }

  .el-menu-item {
    position: relative;

    .el-menu-item--hover {
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      height: 56px;
      background-color: $color-primary;
    }

    &:hover,
    &:focus {
      .el-menu-item--hover {
        width: 4px;
      }
    }
    &.is-active {
      background-color: #e8f3ff;
    }
  }

  .el-menu-item.is-active .svg-icon {
    color: $menuActiveText;
  }

  // the scroll bar appears when the subMenu is too long
  > .el-menu--popup {
    min-width: 146px;
    max-height: 100vh;
    overflow-y: auto;

    &::-webkit-scrollbar-track-piece {
      background: #d3dce6;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #99a9bf;
      border-radius: 20px;
    }
  }
}
</style>
